import { actionCreatorAsync } from 'client/actions/index'
import { getAccountingConnectionStatus } from 'client/components/AgerasAccounting/helpers'
import userflow from 'userflow.js'

import { convertPosixToBCP47Locale, defaultLocales } from './language'

export const initializeUserflow = () => {
  return async (dispatch, getState) => {
    await dispatch(
      actionCreatorAsync('INITIALIZE_USERFLOW', async () => {
        try {
          const { company, settings, subscriptionManagement, token } = getState()

          if (company.randomBucket >= 0 && token.userId && settings) {
            const accountingStatus = getAccountingConnectionStatus(company, settings)
            const {
              country,
              language,
              randomBucket,
              name: companyName,
              insertTime,
              globalId: companyGlobalId,
            } = company
            const { email, creationDate } = token
            const userGlobalId = token?.['custom:globalId']
            const localeCode = defaultLocales?.[language] ? convertPosixToBCP47Locale(defaultLocales[language]) : null

            if (!window.initialConfiguration?.userflowApiKey) {
              console.error('Userflow API key is missing. Skipping initialization.')
              return
            }

            if (!userGlobalId) {
              console.error('globalId is missing. Skipping initialization.')
              return
            }

            await userflow.init(window.initialConfiguration.userflowApiKey)

            // Identifying the user using globalId
            await userflow.identify(userGlobalId, {
              globalId: userGlobalId,
              email,
              accounting_status: accountingStatus,
              locale_code: localeCode,
              signed_up_at: new Date(Number(creationDate)).toISOString(),
            })

            // Grouping under company/organization
            if (!companyGlobalId) {
              console.error('companyGlobalId is missing. Skipping company/organization grouping.')
              return
            }

            const subscriptionProductPlan = subscriptionManagement?.companySubscription?.subscription?.plan?.name

            await userflow.group(companyGlobalId, {
              country,
              createdAt: insertTime,
              name: companyName,
              randomBucket,
              subscriptionProductPlan,
              type: 'organization',
            })
          }
        } catch (error) {
          console.error('Failed to initialize Userflow: ', error)
        }
      }),
    )
  }
}
